import { useContext } from 'react';

import { listStoreContext } from '../list-store';

export const useDataListContext = () => {
  const { dispatch, store } = useContext(listStoreContext);
  return { dispatch, store };
};
